import { useState } from 'react';

import {
  getFilesFromDropzoneDrop,
  getFilesFromSelectionEvent,
  getSelectMediaDropzoneProps,
  getSelectMediaInputProps,
} from './internals';
import MediaFile from './MediaFile';
import MediaSelectionError from './MediaSelectionError';
import { RSDKMedia, SelectMediaHookAPI, SelectMediaResult } from './types';

const useSelectMedia: RSDKMedia['useSelectMedia'] = (opts = {}) => {
  const [selectedMedia, setSelectedMedia] = useState<MediaFile[]>([]);
  const [error, setError] = useState<MediaSelectionError>();

  const handleSelectionResult = (result: SelectMediaResult): void => {
    if (result.isOk()) {
      if (error) {
        setError(undefined);
      }
      setSelectedMedia(result.value);
      if (opts.onSelectionSuccess) {
        opts.onSelectionSuccess(result.value);
      }
    } else {
      console.error(result.error); // eslint-disable-line no-console
      setError(result.error);
    }
  };

  const handleInputChange: SelectMediaHookAPI['inputProps']['onChange'] = async (e) => {
    handleSelectionResult(await getFilesFromSelectionEvent(e));
  };

  const handleDropzoneDrop: SelectMediaHookAPI['dropzoneProps']['onDrop'] = async (...args) => {
    handleSelectionResult(await getFilesFromDropzoneDrop(...args));
  };

  return {
    error,
    inputProps: {
      ...getSelectMediaInputProps(opts),
      onChange: handleInputChange,
    },
    dropzoneProps: {
      ...getSelectMediaDropzoneProps(opts),
      onDrop: handleDropzoneDrop,
    },
    selectedMedia,
    selectMedia: () => {
      // eslint-disable-next-line no-console
      console.warn('Calling selectMedia on web has no effect. Use a file input element instead.');
    },
  };
};

export default useSelectMedia;
